import http from "../httpService";
import {getBaseUrl} from "../../config";

;


export const getStageDegree = id => {
  return http.get(
    `${getBaseUrl()}/stage_degree/${id}`
  );
};

export const getStageDegrees = (paginate) => {
  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/stage_degree`
    );
  }
  return http.get(
    `${getBaseUrl()}/stage_degree?${paginate}`
  );
};

export const updateStageDegree = data => {

  return http.put(
    `${getBaseUrl()}/stage_degree/${data.id}`,
    data
  );
};
export const submitStageDegree = data => {

  return http.post(
    `${getBaseUrl()}/stage_degree`,
    data
  );
};
